import dayjs from 'dayjs'

import { MOCK_AUDIO_MAP } from '@/services/mock-data'

export function getSizeImage(imgUrl: string, size: number) {
    return `${imgUrl}?param=${size}x${size}`
}

export function getCount(count: number) {
    if (count < 0) return
    if (count < 10000) {
        return count
    } else if (Math.floor(count / 10000) < 10000) {
        return Math.floor(count / 1000) / 10 + '万'
    } else {
        return Math.floor(count / 10000000) / 10 + '亿'
    }
}

export function getPlayUrl(id: number) {
    // mock 歌曲直接返回可播放的示例音频，保证播放/暂停可用
    if (MOCK_AUDIO_MAP[id]) {
        return MOCK_AUDIO_MAP[id]
    }
    return `https://music.163.com/song/media/outer/url?id=${id}.mp3`
}

/**
 * 格式化日期时间
 * @param time 时间戳或日期字符串
 * @param format 格式字符串，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns 格式化后的日期字符串
 */
export function formatDate(time: string | number | Date, format = 'YYYY-MM-DD HH:mm:ss'): string {
    return dayjs(time).format(format)
}

/**
 * 格式化月份和日期 (MM月dd日)
 * @param time 时间戳或日期字符串
 * @returns 格式化后的日期字符串
 */
export function formatMonthDay(time: string | number | Date): string {
    return dayjs(time).format('MM月DD日')
}

/**
 * 格式化为分钟和秒 (mm:ss)
 * @param time 时间戳或日期字符串
 * @returns 格式化后的时间字符串
 */
export function formatMinuteSecond(time: string | number | Date): string {
    return dayjs(time).format('mm:ss')
}

const PARSE_EXP = /\[(\d{2}):(\d{2})\.(\d{2,3})\](.*)/

/**
 * 解析歌词字符串
 * @param lyricString - 原始歌词字符串
 * @returns 解析后的歌词行数组，每行为 { time: number, content: string }
 */
export function parseLyric(lyricString: string): { time: number; content: string }[] {
    const lines = lyricString.split('\n')
    const lyrics: { time: number; content: string }[] = []
    for (const line of lines) {
        const match = PARSE_EXP.exec(line)
        if (match) {
            const min = parseInt(match[1], 10)
            const sec = parseInt(match[2], 10)
            const ms = match[3].length === 3 ? parseInt(match[3], 10) : parseInt(match[3], 10) * 10
            const time = min * 60 * 1000 + sec * 1000 + ms
            const content = match[4].trim()
            lyrics.push({ time, content })
        }
    }
    return lyrics
}
